import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { dispatch } from "rxjs/internal/observable/pairs";
import { useDebouncedAction } from "../../../../../../helpers/commonFunction";
import { AppState } from "../../../../../../stateManager/store";
import { onSetFontStylesVisibility, onsetClrPicContext } from "../../../../../../stateManager/store/common/action";
import { getComponents, getValue } from "../../helpers";
import { ColorPicker } from "../ColorPicker";
import { FormCreationData } from "../../../../../../stateManager/store/formCreation_v2/types";
import { rgbToHex } from "../../../../../marketplace/apps/helpers";

const DEFAULT_COLOR: string = "properties.styles.common.color";
const DEFAULT_COLOR_V3: string = "properties.styles.$deviceType.color";


type Props = {
  label: string;
  isCheckedIn: boolean;
  defaultValue?: string;
}

const excluded_types = [
  "ExpansionPanel",
  "Row",
  "Column",
  "Divider",
  "Grid",
  "Modal",
  "CustomModal"
]

export const Color = (props: Props) => {
  const { components } = getComponents()
  const { selectedElementId, deviceType, isCoreV3, computedStyles, wrapperComputedStyles } = useSelector((state: AppState) => state.formJson)
  const { isCheckedIn, defaultValue, label } = props;
  const [oldValue, setOldValue] = useState<string>("");
  const [value, setValue] = useDebouncedAction(defaultValue, 500 || "");
  const component: FormCreationData = components[selectedElementId];
  const { colorPickerContext } = useSelector((state: any) => state.common);
  const { type } = component;

  const dispatch=useDispatch();

  const setFontStylesVisibility = (visibility : boolean) =>{
    dispatch(onSetFontStylesVisibility(visibility))
  }
  const setColorPickerVisibility = (visibility: boolean) => {
    dispatch(onsetClrPicContext({ ...colorPickerContext, visibility: visibility }))
  };

  useEffect(() => {
    if (isCoreV3 && component) {
      const previousValue = getValue(component, DEFAULT_COLOR_V3.split("."), deviceType);
      if (previousValue) {
        setValue(previousValue)
        setOldValue(previousValue)
      } else {
        const wrapperStyles = wrapperComputedStyles.hasOwnProperty("color") ? wrapperComputedStyles : computedStyles;
        const clr = wrapperStyles && wrapperStyles.color
        const rgbaValues = clr?.match(/\d+/g).map(Number) || [];
        let hexColor;
        if (rgbaValues.length === 4) {
          hexColor = rgbToHex(rgbaValues[0], rgbaValues[1], rgbaValues[2], rgbaValues[3]);
        } else if (rgbaValues.length === 3) {
          hexColor = rgbToHex(rgbaValues[0], rgbaValues[1], rgbaValues[2]);
        } else {
          hexColor = null;
        }
        const color: any = (wrapperStyles && wrapperStyles.color ? hexColor : null);
        setValue(color)
        setOldValue(color)
      }
    }else if (!isCoreV3 && component) {
      const previousValue = getValue(component, DEFAULT_COLOR.split("."), deviceType);
      if (previousValue) {
        setValue(previousValue)
        setOldValue(previousValue)
      }
    }
    // eslint-disable-next-line
  }, [isCoreV3, component, deviceType, computedStyles]);

  if (isCoreV3 && excluded_types.includes(type)) {
    return null
  }

  return (
    <ColorPicker
      pickerkey="color"
      label="Color"
      value={value}
      open={() => {
        setFontStylesVisibility(false)
        dispatch(onsetClrPicContext({
          value:value,
          placeholder: "",
          where: isCoreV3 ? DEFAULT_COLOR_V3 : DEFAULT_COLOR,
          visibility:true,
        }))}}
        visibility={colorPickerContext?.visibility}
        close={()=>setColorPickerVisibility(false)}
    />
  )
};
